import { useEffect, useState } from 'react';

import { useQuery } from '@apollo/client';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import type { CuiOptionType } from '@crehana/ui';
import { notEmpty } from '@crehana/utils';
import { useRouter } from 'next/router';

import { orderOptions } from '@/shared/utils';
import type { TOption } from '@/views/AdminDashboard/components';
import useAdminDashboard from '@/views/AdminDashboard/hooks/useAdminDashboard';
import useDebounce from '@/views/AdminDashboard/hooks/useDebounce';

import GET_ORGANIZATION_CUSTOM_FIELDS from './graphql/GetB2bCustomFields.v4.b2b.graphql';
import type {
  GetB2bCustomFields,
  GetB2bCustomFieldsVariables,
} from './graphql/types/GetB2bCustomFields';

export const useOrganizationCustomFields = () => {
  const { debounceValue: debouncedSearchKey, handleChange } = useDebounce();
  const router = useRouter();
  const { slug: routerSlug } = router.query as { slug: string };

  const { slug } = useAdminDashboard();
  const { data, refetch, loading, updateQuery } = useQuery<
    GetB2bCustomFields,
    GetB2bCustomFieldsVariables
  >(GET_ORGANIZATION_CUSTOM_FIELDS, {
    variables: {
      slug: slug || routerSlug,
      searchKey: debouncedSearchKey,
    },
    context: { clientName: 'v4.b2b' },
  });
  const [options, setOptions] = useState<TOption[]>();
  const totalCount = data?.b2bCustomFields?.totalCount || 0;

  const customFields = data?.b2bCustomFields?.edges?.filter(notEmpty) || [];

  const customFieldsAsOptions = customFields
    .map(
      el =>
        ({
          label: el.node.name,
          value: el.node.originalId,
        }) as CuiOptionType<string>,
    )
    .sort(orderOptions);
  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(() => {
    const attributesOptionsList =
      customFields?.map(el => ({
        value: el?.node?.originalId,
        label: el?.node?.name || '',
        subItems:
          el.node?.answers?.map((tag, ind) => ({
            value: `${tag}_${ind}` || '',
            label: tag || '',
            isChecked: false,
          })) || [],
      })) || [];
    setOptions(attributesOptionsList);
  }, [data]);

  return {
    refetch,
    loading,
    handleChange,
    attributesOptionsList: options,
    customFields,
    customFieldsAsOptions,
    totalCount,
    updateQuery,
  };
};
